export const dashboardConstants = {


  // LOADING REQUEST
  LOADING_REQUEST:"LOADING_REQUEST",

  // Dashboard Dashboard Dropdown Campaigns List
  LOAD_CAMPAIGNS: "LOAD_CAMPAIGNS",
  LOAD_CAMPAIGNS_ERROR:"LOAD_CAMPAIGNS_ERROR",

  // Dashboard Campaign Activiy  Data
  LOAD_CAMPAIGN_ACTIVITY_DATA: "LOAD_CAMPAIGN_ACTIVITY_DATA",
  LOAD_CAMPAIGN_ACTIVITY_ERROR: "LOAD_CAMPAIGN_ACTIVITY_ERROR",

  // Dashboard Campaign Counts  Data

  LOAD_CAMPAIGN_COUNT:"LOAD_CAMPAIGN_COUNT",
  LOAD_CAMPAIGN_COUNT_ERROR:"LOAD_CAMPAIGN_COUNT_ERROR",


  // Dashborad Pie Activity Data

  LOAD_CAMPAIGN_PIE_DATA:"LOAD_CAMPAIGN_PIE_DATA",
  LOAD_CAMPAIGN_PIE_DATA_ERROR:"LOAD_CAMPAIGN_PIE_DATA_ERROR",

  // Dasboard competencies Data

  LOAD_COMPETENCIES_ASSESSMENTS_SUCCESS:"LOAD_COMPETENCIES_ASSESSMENTS_SUCCESS",
  LOAD_COMPETENCIES_ASSESSMENTS_ERROR:"LOAD_COMPETENCIES_ASSESSMENTS_ERROR",

};
